import { z } from 'zod';

import { removeWhitespace } from '@clovyr/pollen/util/string';

export const validateSecretKey = z.string().refine((key) => removeWhitespace(key).length === 52, {
  message: 'Secret key must be exactly 52 characters',
});
